<div #countrySelect class="standard-form-field country-select-container country-select-{{ fieldKey }}">
  <!-- LABEL -->
  <label [id]="'label-countrySelect-' + fieldKey" [class.invalid]="fieldControl.touched && fieldControl.invalid">
    {{ 'PERSONAL_DATA_FORM.' + fieldLabelKey + '.MAIN-LABEL' | translate }}

    <ng-container *ngIf="isRequired">
      <span aria-hidden="true">&nbsp;*</span>
      <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
    </ng-container>
  </label>

  <!-- INPUT -->
  <ng-select
    *ngIf="countriesList?.length"
    [id]="'countrySelect-' + fieldKey"
    class="select-short-dropdown"
    dropdownPosition="bottom"
    bindLabel="label"
    bindValue="value"
    appendTo="body"
    [formControl]="fieldControl"
    [items]="countriesList"
    [required]="isRequired"
    [inputAttrs]="{
      autocomplete: 'off',
      'aria-required': isRequired ? 'true' : 'false',
      'aria-invalid': fieldControl.invalid ? 'true' : 'false',
      'aria-labelledby': 'label-countrySelect-' + fieldKey,
      'aria-describedby': fieldControl.invalid && fieldControl.touched ? 'error-countrySelect-' + fieldKey : null
    }">
  </ng-select>

  <!-- PLACEHOLDER -->
  <div class="ng-select-placeholder" *ngIf="!fieldControl.value">
    {{ 'PERSONAL_DATA_FORM.' + fieldLabelKey + '.PLACEHOLDER' | translate }}
  </div>

  <!-- ERROR -->
  <div
    *ngIf="fieldControl.touched && fieldControl.invalid"
    [id]="'error-countrySelect-' + fieldKey"
    class="ng-select-error">
    {{ fieldControl.errors | errorsFormatingAndTranslate }}
  </div>
</div>
